
function myAppointments(){        
    return process.env.VUE_APP_PATIENT_URL 
  }
  
  function myMedicalRecords(){        
    return process.env.VUE_APP_PATIENT_URL + "/my-medical-records/"
  }

  function myQuestions(){        
    return process.env.VUE_APP_PATIENT_URL + "/my-questions/"
  }

  function myProfile(){        
    return process.env.VUE_APP_PATIENT_URL + "/my-profile/"
  }

  function updateProfile(){        
    return process.env.VUE_APP_PATIENT_URL + "/update-profile/"
  }
  

export {myAppointments,myMedicalRecords,myQuestions,myProfile,updateProfile};